<template>
  <div>
    <h1>Edit Interview Question</h1>
    <div class="row reading-form-container">
      <div class="small-12 columns">
        <button class="button-green" @click="updateInterviewQuestion">
          Update Interview Question
        </button>
      </div>
      <div class="small-3 columns">Name</div>
      <div class="small-9 columns">
        <input v-model="name" type="text" class="input-box-course-creators" />
      </div>
      <div class="small-3 columns">Time Allocated (sec)</div>
      <div class="small-9 columns">
        <input
          v-model="timeAllocated"
          type="number"
          step="1"
          class="input-box-course-creators"
        />
      </div>
      <div class="small-3 columns">Buffer Time (sec)</div>
      <div class="small-9 columns">
        <input
          v-model="readingTime"
          type="number"
          step="1"
          class="input-box-course-creators"
        />
      </div>
      <div class="row">
        <div class="small-8 columns">
          <simplemde
            v-model="questionContent"
            uniqueId="edyst-interview-question-edit-content"
          ></simplemde>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import simplemde from "@/components/simpleMarkdownEditor/SimpleMarkdown"

export default {
  components: { simplemde },
  data() {
    return {
      type: 7,
      interviewQuestion: undefined,
      name: undefined,
      readingTime: undefined,
      timeAllocated: undefined,
      questionContent: undefined,
    }
  },
  mounted() {
    this.getQuestion()
  },
  methods: {
    getQuestion() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.interviewQuestion = res.data.data
        this.name = this.interviewQuestion.name
        window.pageTitle = `Edit - ${this.name}`
        this.readingTime = this.interviewQuestion.reading_time
        this.timeAllocated = this.interviewQuestion.time_allocated
        this.questionContent = this.interviewQuestion.content
      })
    },
    updateInterviewQuestion() {
      const payload = {
        type: this.type,
        name: this.name,
        reading_time: this.readingTime,
        time_allocated: this.timeAllocated,
        content: this.questionContent,
        is_required: this.interviewQuestion.is_required,
      }
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(() => {
          this.$router.push("/interview/")
        })
        .catch(error => {
          console.error(
            "Failed to update quesiton. Server responded with",
            error
          )
        })
    },
  },
}
</script>

<style scoped></style>
